export const phoneNumber = '844-994-EARN (3276)';
export const phoneNumberNumeric = '844-994-3276';
export const supportEmail = 'support.us@raisin.com';
export const ddPrivacyAllow = 'dd-privacy-allow';
export const zendeskBaseUrl = 'https://support.raisin.com/hc/en-us';
export const CallableType = 'Callable';
